import { __decorate, __metadata } from "tslib";
import { Injectable } from '@angular/core';
import { GridStateService } from './grid-state.service';
let GridStateAddToClearGuard = class GridStateAddToClearGuard {
    constructor(_gridStateService) {
        this._gridStateService = _gridStateService;
    }
    canDeactivate(component) {
        const gridId = component.gridConfig.localStorageKey;
        if (!gridId) {
            return true;
        }
        this._gridStateService.addToClearList(gridId);
        return true;
    }
};
GridStateAddToClearGuard.ctorParameters = () => [
    { type: GridStateService }
];
GridStateAddToClearGuard = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [GridStateService])
], GridStateAddToClearGuard);
export { GridStateAddToClearGuard };
